export default __webpack_public_path__ + "static/placeholder_img-663e4692f34319d98f8339191c1e3f2b.webp";